import { cardImageSources, type GenericCharacter } from './types'

export const genericSirena: GenericCharacter = {
  id: 'generic-sirena',
  enabled: true,
  order: 8,
  displayName: 'Perla',
  icon: '🧜‍♀️',
  imageSources: cardImageSources('generic-sirena'),
}
